/* ============================================================================
 * MB Parts — i18n translations + static page content (client-side).
 * Product data is injected by Liquid (snippets/mb-shopify-data.liquid).
 * ==========================================================================*/
window.MB = window.MB || {};

/* ---------------------------------------------------------------------------
 * Translations (English / Dutch). Toggled client-side via [data-i18n].
 * ------------------------------------------------------------------------ */
MB.i18n = {
  en: {
    'nav.home': 'Home',
    'nav.about': 'About Us',
    'nav.faq': 'FAQ',
    'nav.contact': 'Contact Us',
    'nav.shop': 'Shop',
    'header.tagline': 'Parts for patios, verandas & window and door frames',
    'header.search': 'Search parts…',
    'cart.title': 'Your cart',
    'cart.empty': 'Your cart is empty.',
    'cart.subtotal': 'Subtotal',
    'cart.checkout': 'Checkout',
    'cart.remove': 'Remove',
    'cart.added': 'Added to cart',
    'cart.btw': 'BTW (21%)',
    'cart.total': 'Total',
    'cart.company': 'Company name (optional)',
    'cart.btw_number': 'BTW number (optional)',

    'hero.slide1.title': 'Aluminium Veranda Systems',
    'hero.slide1.text': 'Durable profiles, brackets and fixings for modern verandas.',
    'hero.slide2.title': 'Glass Roof & Wall Systems',
    'hero.slide2.text': 'Sliding rollers, seals and glazing hardware built to last.',
    'hero.slide3.title': 'Window Frame Hardware',
    'hero.slide3.text': 'Hinges, locks and weather seals for every window.',
    'hero.slide4.title': 'Door Frame Solutions',
    'hero.slide4.text': 'Handles, multipoint locks and closers for aluminium doors.',
    'hero.cta': 'Shop all parts',

    'mostsold.title': 'Most Sold',
    'mostsold.subtitle': 'Our customers\' favourite parts',

    'grid.title': 'Our Products',
    'grid.subtitle': 'Quality hardware and parts for verandas and construction',
    'nav.products': 'Products',

    'filter.all': 'All',
    'filter.dak': 'Dak',
    'filter.veranda': 'Veranda',
    'filter.other': 'Other',
    'card.sale': 'Sale',
    'card.out': 'Sold out',
    'card.view': 'View product',

    'pdp.back': 'Back to products',
    'pdp.stock': 'In stock',
    'pdp.stockUnit': 'units',
    'pdp.outofstock': 'Out of stock',
    'pdp.delivery': '2-4 days',
    'pdp.secure': 'Secure payment',
    'pdp.color': 'Colour',
    'pdp.size': 'Size',
    'pdp.qty': 'Quantity',
    'pdp.add': 'Add to My Basket',
    'pdp.sku': 'SKU',
    'pdp.category': 'Category',
    'pdp.notfound': 'Product not found.',

    'about.title': 'About Us',
    'faq.title': 'Frequently Asked Questions',

    'contact.title': 'Contact Us',
    'contact.subtitle': 'We are happy to help. Choose a form below.',
    'contact.f1.title': 'Reach out / Suggestion / Complaint',
    'contact.f1.name': 'Your name',
    'contact.f1.email': 'Email address',
    'contact.f1.type': 'Subject',
    'contact.f1.type.reach': 'Reach out',
    'contact.f1.type.suggestion': 'Suggestion',
    'contact.f1.type.complaint': 'Complaint',
    'contact.f1.message': 'Your message',
    'contact.f1.submit': 'Send message',
    'contact.f2.title': 'Request a product',
    'contact.f2.text': 'Is a part missing from our shop? Tell us what you need.',
    'contact.f2.pname': 'Product name',
    'contact.f2.desc': 'Description',
    'contact.f2.image': 'Product image',
    'contact.f2.imageHint': 'Upload a photo or drawing (required)',
    'contact.f2.submit': 'Send request',
    'contact.required': 'This field is required.',
    'contact.sent': 'Thank you! Your message has been sent. (demo)',

    'login.title': 'Log in',
    'login.email': 'Email address',
    'login.password': 'Password',
    'login.submit': 'Log in',
    'login.forgot': 'Forgot password?',
    'login.no_account': 'No account yet?',
    'login.register': 'Register',
    'login.register_title': 'Create account',
    'login.first_name': 'First name',
    'login.last_name': 'Last name',
    'login.register_submit': 'Create account',
    'login.have_account': 'Already have an account?',
    'login.guest': 'Continue as guest',
    'login.welcome': 'Welcome',
    'login.welcome_text': 'Log in for a personalised experience, or continue as guest.',
    'login.type_personal': 'Personal',
    'login.type_company': 'Company',
    'login.company_name': 'Company name',
    'login.kvk': 'KVK number',
    'login.address': 'Address',
    'login.city': 'City',
    'login.postcode': 'Postcode',
    'login.phone': 'Phone number',
    'login.password_confirm': 'Confirm password',
    'login.err_password_match': 'Passwords do not match',
    'login.err_kvk': 'KVK number must be 8 digits',
    'login.err_btw': 'Invalid BTW number (e.g. NL000000000B00)',
    'login.err_postcode': 'Invalid postcode format',
    'login.or': 'or',

    'account.profile': 'My Account',
    'account.orders': 'Orders',
    'account.logout': 'Log out',

    'specs.title': 'Technical Specifications',
    'pdp.description': 'Description',
    'pdp.related': 'Related Products',

    'dawn.add_to_cart': 'Add to cart',
    'dawn.sold_out': 'Sold out',
    'dawn.tax_included': 'Tax included.',
    'dawn.more_payment': 'More payment options',
    'dawn.share': 'Share',
    'dawn.quantity': 'Quantity',
    'dawn.decrease': 'Decrease quantity for',
    'dawn.increase': 'Increase quantity for',
    'dawn.buy_with': 'Buy with',
    'dawn.cart_title': 'Your cart',
    'dawn.product': 'Product',
    'dawn.total_col': 'Total',
    'dawn.subtotal': 'Subtotal',
    'dawn.estimated_total': 'Estimated total',
    'dawn.tax_note': 'Taxes included. Discounts and shipping calculated at checkout.',
    'dawn.checkout': 'Check out',
    'dawn.empty': 'Your cart is empty',
    'dawn.continue': 'Continue shopping',
    'dawn.remove': 'Remove',
    'dawn.return_shop': 'Return to shop',
    'dawn.have_account': 'Have an account?',
    'dawn.login': 'Log in',
    'dawn.faster_checkout': 'to check out faster.',
    'dawn.loading': 'Loading...',
    'dawn.tax_line': 'Tax (21%)',
    'dawn.size': 'Size',
    'dawn.colour': 'Colour',
    'dawn.description': 'Description',
    'dawn.variant_soldout': 'Variant sold out or unavailable',
    'dawn.in_cart': 'in cart',
    'dawn.shipping': 'Shipping',
    'dawn.back_to_products': 'Back to products',
    'dawn.normal_price': 'Regular price',
    'dawn.sale_price': 'Sale price',
    'dawn.shipping_calc': 'calculated at checkout.',
    'dawn.in_cart_paren': 'in cart)',
    'dawn.skip_to_info': 'Skip to product information',
    'dawn.open_modal': 'open in modal',

    'footer.about': 'Quality hardware and parts for patios, verandas and window & door frames. Trade and DIY welcome.',
    'footer.links': 'Links',
    'footer.categories': 'Categories',
    'footer.contact': 'Contact',
    'footer.rights': 'All rights reserved.',
    'lang.label': 'Language',
    'parallax.slogan': 'Building better spaces — one part at a time.'
  },
  nl: {
    'nav.home': 'Home',
    'nav.about': 'Over ons',
    'nav.faq': 'FAQ',
    'nav.contact': 'Contact',
    'nav.shop': 'Shop',
    'header.tagline': 'Onderdelen voor terrassen, veranda\'s en raam- en deurkozijnen',
    'header.search': 'Zoek onderdelen…',
    'cart.title': 'Je winkelwagen',
    'cart.empty': 'Je winkelwagen is leeg.',
    'cart.subtotal': 'Subtotaal',
    'cart.checkout': 'Afrekenen',
    'cart.remove': 'Verwijderen',
    'cart.added': 'Toegevoegd aan winkelwagen',
    'cart.btw': 'BTW (21%)',
    'cart.total': 'Totaal',
    'cart.company': 'Bedrijfsnaam (optioneel)',
    'cart.btw_number': 'BTW-nummer (optioneel)',

    'hero.slide1.title': 'Aluminium Verandasystemen',
    'hero.slide1.text': 'Duurzame profielen, beugels en bevestigingen voor moderne veranda\'s.',
    'hero.slide2.title': 'Glazen Dak- & Wandsystemen',
    'hero.slide2.text': 'Schuifrollers, afdichtingen en beglazingsbeslag die lang meegaan.',
    'hero.slide3.title': 'Raamkozijn Beslag',
    'hero.slide3.text': 'Scharnieren, sloten en tochtafdichtingen voor elk raam.',
    'hero.slide4.title': 'Deurkozijn Oplossingen',
    'hero.slide4.text': 'Krukken, meerpuntssloten en drangers voor aluminium deuren.',
    'hero.cta': 'Bekijk alle onderdelen',

    'mostsold.title': 'Meest Verkocht',
    'mostsold.subtitle': 'De favoriete onderdelen van onze klanten',

    'grid.title': 'Onze Producten',
    'grid.subtitle': 'Kwaliteitsbeslag en onderdelen voor veranda\'s en constructie',
    'nav.products': 'Producten',

    'filter.all': 'Alle',
    'filter.dak': 'Dak',
    'filter.veranda': 'Veranda',
    'filter.other': 'Overig',
    'card.sale': 'Korting',
    'card.out': 'Uitverkocht',
    'card.view': 'Bekijk product',

    'pdp.back': 'Terug naar producten',
    'pdp.stock': 'Op voorraad',
    'pdp.stockUnit': 'stuks',
    'pdp.outofstock': 'Niet op voorraad',
    'pdp.delivery': '2-4 dagen',
    'pdp.secure': 'Veilig betalen',
    'pdp.color': 'Kleur',
    'pdp.size': 'Maat',
    'pdp.qty': 'Aantal',
    'pdp.add': 'In Mijn Winkelwagen',
    'pdp.sku': 'SKU',
    'pdp.category': 'Categorie',
    'pdp.notfound': 'Product niet gevonden.',

    'about.title': 'Over ons',
    'faq.title': 'Veelgestelde vragen',

    'contact.title': 'Contact',
    'contact.subtitle': 'We helpen je graag. Kies hieronder een formulier.',
    'contact.f1.title': 'Contact / Suggestie / Klacht',
    'contact.f1.name': 'Je naam',
    'contact.f1.email': 'E-mailadres',
    'contact.f1.type': 'Onderwerp',
    'contact.f1.type.reach': 'Contact',
    'contact.f1.type.suggestion': 'Suggestie',
    'contact.f1.type.complaint': 'Klacht',
    'contact.f1.message': 'Je bericht',
    'contact.f1.submit': 'Verstuur bericht',
    'contact.f2.title': 'Product aanvragen',
    'contact.f2.text': 'Mist er een onderdeel in onze shop? Vertel ons wat je nodig hebt.',
    'contact.f2.pname': 'Productnaam',
    'contact.f2.desc': 'Omschrijving',
    'contact.f2.image': 'Productafbeelding',
    'contact.f2.imageHint': 'Upload een foto of tekening (verplicht)',
    'contact.f2.submit': 'Verstuur aanvraag',
    'contact.required': 'Dit veld is verplicht.',
    'contact.sent': 'Bedankt! Je bericht is verzonden. (demo)',

    'login.title': 'Inloggen',
    'login.email': 'E-mailadres',
    'login.password': 'Wachtwoord',
    'login.submit': 'Inloggen',
    'login.forgot': 'Wachtwoord vergeten?',
    'login.no_account': 'Nog geen account?',
    'login.register': 'Registreer',
    'login.register_title': 'Account aanmaken',
    'login.first_name': 'Voornaam',
    'login.last_name': 'Achternaam',
    'login.register_submit': 'Account aanmaken',
    'login.have_account': 'Heb je al een account?',
    'login.guest': 'Doorgaan als gast',
    'login.welcome': 'Welkom',
    'login.welcome_text': 'Log in voor een persoonlijke ervaring, of ga verder als gast.',
    'login.type_personal': 'Particulier',
    'login.type_company': 'Bedrijf',
    'login.company_name': 'Bedrijfsnaam',
    'login.kvk': 'KVK-nummer',
    'login.address': 'Adres',
    'login.city': 'Plaats',
    'login.postcode': 'Postcode',
    'login.phone': 'Telefoonnummer',
    'login.password_confirm': 'Wachtwoord bevestigen',
    'login.err_password_match': 'Wachtwoorden komen niet overeen',
    'login.err_kvk': 'KVK-nummer moet 8 cijfers zijn',
    'login.err_btw': 'Ongeldig BTW-nummer (bijv. NL000000000B00)',
    'login.err_postcode': 'Ongeldig postcode formaat',
    'login.or': 'of',

    'account.profile': 'Mijn Account',
    'account.orders': 'Bestellingen',
    'account.logout': 'Uitloggen',

    'specs.title': 'Technische Specificaties',
    'pdp.description': 'Beschrijving',
    'pdp.related': 'Gerelateerde Producten',

    'dawn.add_to_cart': 'Aan winkelwagen toevoegen',
    'dawn.sold_out': 'Uitverkocht',
    'dawn.tax_included': 'Belastingen inbegrepen.',
    'dawn.more_payment': 'Meer betalingsopties',
    'dawn.share': 'Delen',
    'dawn.quantity': 'Aantal',
    'dawn.decrease': 'Aantal verlagen voor',
    'dawn.increase': 'Aantal verhogen voor',
    'dawn.buy_with': 'Kopen met',
    'dawn.cart_title': 'Je winkelwagen',
    'dawn.product': 'Product',
    'dawn.total_col': 'Totaal',
    'dawn.subtotal': 'Subtotaal',
    'dawn.estimated_total': 'Geschat totaal',
    'dawn.tax_note': 'Belastingen inbegrepen. Kortingen en verzending worden bij de checkout berekend.',
    'dawn.checkout': 'Afrekenen',
    'dawn.empty': 'Je winkelwagen is leeg',
    'dawn.continue': 'Verder winkelen',
    'dawn.remove': 'Verwijderen',
    'dawn.return_shop': 'Terugkeren naar winkel',
    'dawn.have_account': 'Heb je een account?',
    'dawn.login': 'Inloggen',
    'dawn.faster_checkout': 'om sneller af te rekenen.',
    'dawn.loading': 'Bezig met laden...',
    'dawn.tax_line': 'BTW (21%)',
    'dawn.size': 'Maat',
    'dawn.colour': 'Kleur',
    'dawn.description': 'Beschrijving',
    'dawn.variant_soldout': 'Variant uitverkocht of niet beschikbaar',
    'dawn.in_cart': 'in winkelwagen',
    'dawn.shipping': 'Verzendkosten',
    'dawn.back_to_products': 'Terug naar producten',
    'dawn.normal_price': 'Normale prijs',
    'dawn.sale_price': 'Aanbiedingsprijs',
    'dawn.shipping_calc': 'worden berekend bij de checkout.',
    'dawn.in_cart_paren': 'in winkelwagen)',
    'dawn.skip_to_info': 'Ga direct naar productinformatie',
    'dawn.open_modal': 'openen in modaal',

    'footer.about': 'Kwaliteitsbeslag en onderdelen voor terrassen, veranda\'s en raam- & deurkozijnen. Handel en doe-het-zelf welkom.',
    'footer.links': 'Links',
    'footer.categories': 'Categorieën',
    'footer.contact': 'Contact',
    'footer.rights': 'Alle rechten voorbehouden.',
    'lang.label': 'Taal',
    'parallax.slogan': 'Betere ruimtes bouwen — onderdeel voor onderdeel.'
  }
};

/* Long-form page content (About + FAQ), per language. */
MB.pages = {
  about: {
    en: `
      <p>MB Parts is a specialist supplier of hardware and replacement parts for
      patios, verandas and aluminium window and door frames. From a single screw
      to a complete organiser case, we keep the components that keep outdoor
      living spaces and façades working.</p>
      <p>Founded by installers who were tired of hunting for the right part, we
      built a catalogue focused on quality, availability and clear specifications.
      Every item is selected for durability against Dutch weather — rain, wind and
      the occasional bit of sun.</p>
      <h3>What we do</h3>
      <ul>
        <li><strong>Patio &amp; veranda parts</strong> — roof profiles, sliding-glass rollers, seals, brackets, LED accessories and drainage.</li>
        <li><strong>Frame hardware</strong> — hinges, multipoint locks, handles, weatherstrips and glazing beads.</li>
        <li><strong>Storage &amp; organisation</strong> — assortment boxes and bins so your parts are always to hand.</li>
      </ul>
      <h3>Trade &amp; DIY</h3>
      <p>Whether you fit verandas for a living or you are maintaining your own
      home, you will find the right part with the right specification. Not sure
      what you need? Send us a photo through our contact page and we will help.</p>
    `,
    nl: `
      <p>MB Parts is een gespecialiseerde leverancier van beslag en
      vervangingsonderdelen voor terrassen, veranda\'s en aluminium raam- en
      deurkozijnen. Van één schroef tot een complete opbergkoffer: wij hebben de
      onderdelen die buitenruimtes en gevels laten werken.</p>
      <p>Opgericht door monteurs die het zat waren om naar het juiste onderdeel te
      zoeken, hebben we een assortiment opgebouwd gericht op kwaliteit,
      beschikbaarheid en duidelijke specificaties. Elk artikel is geselecteerd op
      duurzaamheid tegen het Nederlandse weer — regen, wind en af en toe wat zon.</p>
      <h3>Wat we doen</h3>
      <ul>
        <li><strong>Terras- &amp; verandaonderdelen</strong> — dakprofielen, schuifglasrollers, afdichtingen, beugels, LED-accessoires en afwatering.</li>
        <li><strong>Kozijnbeslag</strong> — scharnieren, meerpuntssloten, krukken, tochtstrips en glaslatten.</li>
        <li><strong>Opslag &amp; ordening</strong> — sorteerboxen en bakken zodat je onderdelen altijd bij de hand zijn.</li>
      </ul>
      <h3>Handel &amp; doe-het-zelf</h3>
      <p>Of je nu veranda\'s plaatst voor je werk of je eigen huis onderhoudt, je
      vindt het juiste onderdeel met de juiste specificatie. Niet zeker wat je
      nodig hebt? Stuur ons een foto via onze contactpagina en we helpen je.</p>
    `
  },
  faq: {
    en: [
      ['Do you ship across the Netherlands and the EU?',
       'Yes. We ship throughout the Netherlands with next-business-day delivery on in-stock parts, and across the EU within 2–5 business days.'],
      ['Can I order a single screw or a small quantity?',
       'Absolutely. There is no minimum order. Fixings such as screws and seals are also available in bulk assortment boxes for larger jobs.'],
      ['How do I know a part fits my veranda or frame?',
       'Every product page lists dimensions, material and compatible systems. If you are unsure, send a photo through the “Request a product” form on our contact page and we will confirm the right part.'],
      ['What if the part I need is not listed?',
       'Use the product-request form on our Contact page. Add a photo, name and description, and we will source it or add it to the catalogue.'],
      ['What is your return policy?',
       'Unused parts in original packaging can be returned within 30 days. Custom-cut profiles are excluded.'],
      ['Do you offer trade accounts?',
       'Yes. Professional installers can request a trade account for volume pricing — mention it in the contact form.']
    ],
    nl: [
      ['Verzenden jullie door heel Nederland en de EU?',
       'Ja. We verzenden door heel Nederland met levering op de volgende werkdag voor voorraadartikelen, en binnen de EU in 2–5 werkdagen.'],
      ['Kan ik één schroef of een kleine hoeveelheid bestellen?',
       'Zeker. Er is geen minimale bestelling. Bevestigingen zoals schroeven en afdichtingen zijn ook verkrijgbaar in grote sorteerboxen voor grotere klussen.'],
      ['Hoe weet ik of een onderdeel op mijn veranda of kozijn past?',
       'Elke productpagina vermeldt afmetingen, materiaal en compatibele systemen. Twijfel je? Stuur een foto via het formulier “Product aanvragen” op onze contactpagina en wij bevestigen het juiste onderdeel.'],
      ['Wat als het onderdeel dat ik nodig heb er niet bij staat?',
       'Gebruik het aanvraagformulier op onze contactpagina. Voeg een foto, naam en omschrijving toe en we zoeken het voor je of voegen het toe aan het assortiment.'],
      ['Wat is jullie retourbeleid?',
       'Ongebruikte onderdelen in originele verpakking kunnen binnen 30 dagen worden geretourneerd. Op maat gezaagde profielen zijn uitgesloten.'],
      ['Bieden jullie zakelijke accounts aan?',
       'Ja. Professionele monteurs kunnen een zakelijk account aanvragen voor staffelprijzen — vermeld dit in het contactformulier.']
    ]
  }
};

/* Product data + currency are now injected by Liquid (snippets/mb-shopify-data.liquid). */
